import FormattedTextMessage from 'components/FormattedTextMessage';
import Timestamp from 'components/Timestamp';
import { PARTICIPANT_PREFIX } from 'constants/twilio';
import { useConversation } from 'hooks/conversation';
import { AuthorHeader } from 'routes/Chat/Messages/GetAuthorHeader';
import WithDelayedAnimation from 'routes/Chat/Messages/WithDelayedAnimation/WithDelayedAnimation';
import { MESSAGE_ALIGN } from 'routes/Chat/Messages/constants';
import { StyledMessageWrapper } from 'routes/Chat/Messages/styles';
import { FormattedMessagesType } from 'routes/Chat/Messages/types';
import { htmlId } from 'utils/html';
import { isLastMessage } from 'utils/twilio';

type TTextMessage = {
  message: FormattedMessagesType;
};

const TextMessage = ({ message }: TTextMessage) => {
  const { index, author, text, textFormat, timestamp } = message;

  const { conversationState } = useConversation();

  const isCustomerMsg = author.includes(PARTICIPANT_PREFIX.CUSTOMER);
  const isLastTwilioMsg = isLastMessage(index, conversationState.messages.length);
  const isAnimateMsg = !isCustomerMsg && isLastTwilioMsg && conversationState.isAnimateLastMessage;

  const align = isCustomerMsg ? MESSAGE_ALIGN.RIGHT : MESSAGE_ALIGN.LEFT;

  return (
    <StyledMessageWrapper
      id={htmlId(`message-container-${index}`)}
      data-message-type={textFormat.toLocaleLowerCase()}
    >
      {!isCustomerMsg && <AuthorHeader author={author} />}
      <WithDelayedAnimation animate={isAnimateMsg}>
        <FormattedTextMessage
          format={textFormat}
          raw={text}
          message={message}
        ></FormattedTextMessage>
        <Timestamp date={timestamp} align={align} />
      </WithDelayedAnimation>
    </StyledMessageWrapper>
  );
};

export default TextMessage;
